import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import LightingSetDetail from '../../components/light/LightingSetDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { createLightingSet, clearTobeCreatedLightingSet } from '../../redux/luminaire/lightingset_actions';

export class LightingSetCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.lightingSetDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show && nextProps.show !== this.props.show) {
      this.props.clearLS();
    }
  }

  onSaveHandler() {
    const newLS = this.lightingSetDetail.getWrappedInstance().getWrappedInstance().getLSData();
    newLS['bulb_list'] = this.props.TobeCreatedLightingset.bulb_list.map((each_bulb)=>{
      return {
        "bulb_id": each_bulb.bulb.id, 
        "quantity": each_bulb.quantity
      }
    });
    newLS['ballast_list'] = this.props.TobeCreatedLightingset.ballast_list.map((each_ballast)=>{
      return {
        "ballast_id": each_ballast.ballast.id, 
        "quantity": each_ballast.quantity
      }
    });

    this.props.createLS(newLS);
  }

  render() {
    const { isCreating, errorMessage, createLS, t, TobeCreatedLightingset, ...newProps } = this.props;
    const { isSubmittable } = this.state;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create lighting set')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LightingSetDetail
            ref={ref => (this.lightingSetDetail = ref)}
            mode={'create'}
            lightingSet={TobeCreatedLightingset}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="lighting-set-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('creating')}...` : t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    errorMessage: state.lighting.lightingset.errorMessage,
    isCreating: state.lighting.lightingset.isCreating,
    TobeCreatedLightingset: {
      bulb_list: state.lighting.lightingset.tobeCreatedluminaireRel,
      ballast_list: state.lighting.lightingset.tobeCreatedballastRel
    },
  }
};

const mapDispatchToProps = dispatch => ({
  createLS: ls => defaultRejectHandler(dispatch(createLightingSet(ls.name, ls.description, ls.image, ls.bulb_list, ls.ballast_list))),
  clearLS: () => defaultRejectHandler(dispatch(clearTobeCreatedLightingSet())),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(LightingSetCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/lighting_set/LightingSetCreateModal.js